import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TIMEOUT } from "src/global";
import { IBaseState } from "src/interfaces";
import { ISolarGeneratedProps } from "./interfaces";

export default class SolarGenerated extends Component<ISolarGeneratedProps, IBaseState> {
  public constructor(props: ISolarGeneratedProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset className="fieldset-right">
          <legend>Solar Generated</legend>
          <LoadingStatus width={25} height={25} singular={true} type="Watch" />
        </fieldset>
      );
    }

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 6;
    const smInputWidthR = 6;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    const totalSolarReceived = this.props.solarReading - this.props.priorSolarReading;
    const netTotalSolarUsed = this.props.solarGenerated - totalSolarReceived;
    const onPeakSolarReceived = this.props.onPeakSolarReading - this.props.priorOnPeakSolarReading;
    const offPeakSolarCredited = totalSolarReceived - onPeakSolarReceived;
    let onPeakProportional = onPeakSolarReceived / totalSolarReceived;
    onPeakProportional = onPeakProportional * netTotalSolarUsed;
    if (isNaN(onPeakProportional)) {
      onPeakProportional = 0;
    }
    let offPeakProportional = offPeakSolarCredited / totalSolarReceived;
    offPeakProportional = offPeakProportional * netTotalSolarUsed;
    if (isNaN(offPeakProportional)) {
      offPeakProportional = 0;
    }

    return (
      <fieldset className="fieldset-right">
        <legend>Total Solar Generation</legend>
        <FormGroup bsSize="small" controlId="solarGenerated">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Total Solar Generated
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarGenerated}
              onChange={this.props.solarGeneratedChanged}
            />
          </Col>
        </FormGroup>
        <legend>Solar Not Credited</legend>
        <FormGroup bsSize="small" controlId="solarGenerated">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Total Solar Generated
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarGenerated}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="solarReceived">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Solar Received
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={totalSolarReceived}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          smOffset={smLabelWidthR}
          mdOffset={mdLabelWidthR}
          xs={xsInputWidthR}
          sm={smInputWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="netTotalSolarUsed">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Net Total Solar Used
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={netTotalSolarUsed}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          smOffset={smLabelWidthR}
          mdOffset={mdLabelWidthR}
          xs={xsInputWidthR}
          sm={smInputWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="onPeakSolarCredited">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Received
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={onPeakSolarReceived}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="offPeakSolarCredited">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Off-peak Received
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={offPeakSolarCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakProportional">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Proportional
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={onPeakProportional.toFixed(3)}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="offPeakProportional">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Proportional
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={offPeakProportional.toFixed(3)}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/dualrate/SolarGenerated.tsx